import type { SDR } from '@seen/core/models/tasks/sdr/sdr'
import { cn } from '@seen/ui'
import { format as formatDate } from 'date-fns'
import type { JSX } from 'react'
import { Tooltip } from '#src/components/core/tooltip/Tooltip.tsx'
import { TooltipContent } from '#src/components/core/tooltip/TooltipContent.tsx'
import { TooltipTrigger } from '#src/components/core/tooltip/TooltipTrigger.tsx'

type Props = {
  sdr: SDR
  className?: string
  as?: 'span' | 'p'
}

export function SDRTimeRemainingWithTooltip({
  sdr,
  className,
  as: Component = 'span',
}: Props): JSX.Element {
  const { text, className: timeRemainingClassName } = sdr.timeRemaining

  if (text === 'Missed') {
    return (
      <Tooltip delayDuration={100}>
        <TooltipTrigger asChild>
          <Component
            className={cn('font-semibold', timeRemainingClassName, className)}
          >
            {text}
          </Component>
        </TooltipTrigger>
        <TooltipContent>
          Missed due to delayed notification to requestor.
        </TooltipContent>
      </Tooltip>
    )
  }

  const dueDate = sdr.decisionNotificationDate
  const dueDateLabel = dueDate
    ? formatDate(dueDate, 'eeee MM/dd/yy')
    : undefined

  if (dueDateLabel) {
    return (
      <Tooltip delayDuration={100}>
        <TooltipTrigger asChild>
          <Component
            className={cn('font-semibold', timeRemainingClassName, className)}
          >
            {text}
          </Component>
        </TooltipTrigger>
        <TooltipContent>{dueDateLabel}</TooltipContent>
      </Tooltip>
    )
  }

  return (
    <Component
      className={cn('font-semibold', timeRemainingClassName, className)}
    >
      {text}
    </Component>
  )
}
